module.exports = __webpack_public_path__ + "static/media/unit 1-2.a84d9ed2.jpg";